<template>
    <SectionViewLayout
      :title="'settings.filters.labels.title.' + route.params.action"
      :content_state="content_state"
      content_class="filters-form"
      close_route="filters-list"
      close_class="close"
    >
        <template #actions>
            <ActionButton
                @click="onFilterSave()"
                v-tooltip='"global.actions.save"'
                icon="fas fa-save"
                :gtm="{
                    module : 'filter_settings',
                    feature: 'filters_form',
                    block  : `top_actions`,
                    action : 'submit'
                }"
            />
        </template>

        <template #content>
            <form>
                <fieldset>
                    <InputText
                      input_id="sf_ref_name"
                      input_name="name"
                      :input_invalids="properties_validation.invalid"
                      :input_required="true"
                      :input_focus="true"
                      label_text="settings.filters.labels.filter_name"
                      error_text="settings.filters.invalid_name"
                      v-model:input_value="filter.name"
                      @change="onValidateFieldsAfterSubmission()">
                    </InputText>
                </fieldset>
                <fieldset>
                    <legend>{{Language.say('settings.filters.labels.apply_filter')}}</legend>
                    <InputRadio
                      input_name="radio"
                      tag_text="settings.filters.labels."
                      v-model:input_value="filter.combine"
                      :options="props.filters_controller.data.metadata.combine.values">
                    </InputRadio>
                </fieldset>
                <fieldset>
                    <legend>{{Language.say('settings.filters.labels.conditions')}}</legend>
                    <div v-for="condition,index in filter.conditions" :key="condition" class="condition">
                        <p v-if="index != 0">{{Language.say('settings.filters.labels.pick_' + filter.combine)}}</p>

                        <div :id="`sf_ref_condition_${index}`" class="column-group grey-background" >
                            <div class="column-50">
                                <InputSelect
                                  :input_name="`sf_condition_field_${index}`"
                                  tag_text="settings.filters.labels."
                                  v-model:input_value="condition.field"
                                  :options="condition_keys">
                                </InputSelect>
                            </div>
                            <div class="column-50">
                                <InputSelect
                                  :input_name="`sf_condition_test_${index}`"
                                  tag_text="settings.filters.labels."
                                  v-model:input_value="condition.test"
                                  :options="filters_controller.data.metadata.conditions.values[condition.field].tests">
                                </InputSelect>
                            </div>
                            <div class="column-100">
                                <InputText
                                  :input_id="`sf_ref_sf_condition_${index}`"
                                  :input_name="`condition_${index}`"
                                  :input_placeholder="filters_controller.data.metadata.conditions.values[condition.field].validation ? 'E-mail' : 'Valor'"
                                  v-model:input_value="condition.value"
                                  :input_invalids="properties_validation.invalid"
                                  :error_text="`settings.filters.invalid_${condition.field}`"
                                  :options="filters_controller.data.metadata.conditions.values[condition.field].tests"
                                  @change="onValidateFieldsAfterSubmission()">
                                </InputText>
                            </div>
                            <ActionButton v-if="filter.conditions.length > 1"
                              icon="fas fa-trash-alt"
                              text="settings.filters.actions.delete_condition"
                              @click="onConditionDelete(index)"
                            />
                        </div>
                    </div>

                    <ActionButton
                        class="bottom-space"
                        icon="fas fa-plus-circle"
                        text="settings.filters.actions.add_condition"
                        @click="onConditionAdd()"
                    />
                </fieldset>

                <fieldset>
                    <legend>{{Language.say('settings.filters.labels.perform_action')}}</legend>
                        <div class="column-group">
                            <div class="column-50">
                                <InputSelect
                                input_id="sf_ref_folder"
                                input_name="folder"
                                tag_text="settings.filters.labels.metadata."
                                error_text="settings.filters.invalid_folder"
                                :input_invalids="properties_validation.invalid"
                                v-model:input_value="filter.action"
                                :options="filters_controller.data.metadata.actions.values"
                                @change="onValidateFieldsAfterSubmission()">
                              </InputSelect>
                            </div>
                            <div class="column-100 bottom-space" v-if="filter.action === 'Ingo_Rule_User_Move'">
                                <div class="select-folder">
                                    <span v-if="filter.action_value" class="folder" role="button">
                                        <span @click="onFoldersModalOpen()">
                                          <i class="far fa-folder"></i>
                                          {{filter.action_value}}
                                        </span>
                                        <span @click="onRemoveFolderSelected()" class="close" role="button"></span>
                                    </span>
                                    <ActionButton
                                      icon="fas fa-folder"
                                      text="settings.filters.actions.select_folder"
                                      @click="onFoldersModalOpen()"
                                    />
                                </div>
                            </div>
                        </div>
                </fieldset>

                <fieldset v-if="filters_controller.data.metadata.actions.allowed_flags[filter.action]">
                    <legend>{{Language.say('settings.filters.labels.mark_message_' + filter.action)}}</legend>
                    <div class="column-group" id="ref_flags">
                        <InputCheckboxList
                          input_id="sf_ref_flags"
                          input_name="flags"
                          :input_invalids="properties_validation.invalid"
                          :input_value="filter.flags"
                          :options="props.filters_controller.data.metadata.flags.values"
                          tag_text="settings.filters.labels."
                          error_text="settings.filters.invalid_flags"
                          @update:input_value="value => { filter.flags = value; onValidateFieldsAfterSubmission(); }">
                        </InputCheckboxList>
                    </div>
                </fieldset>

                <div class="submit-desktop">
                    <ActionButton v-if="route.name == 'filters-edit'"
                        class="main-action"
                        icon="fas fa-trash-alt"
                        text="settings.filters.actions.delete"
                        @click="onDeleteFilter()"
                    />
                    <ActionButton
                      class="main-action"
                      icon="fas fa-save"
                      text="global.actions.save"
                      @click="onFilterSave()"
                      :gtm="{
                          module : 'filter_settings',
                          feature: 'filters_form',
                          block  : 'bottom_actions',
                          action : 'submit'
                      }"
                    />
                </div>
            </form>

            <ConfirmModal v-if="delete_warning_visible"
                @actionCancel='onDeleteCancel()'
                @actionConfirm="onDeleteConfirm()"
                confirm_class="danger"
            >
                <template #modal_body>
                    <p>{{Language.say('settings.filters.delete_warning_text')}}</p>
                    <p>{{Language.say('settings.filters.delete_warning_reversible')}}</p>
                </template>
            </ConfirmModal>

            <FoldersSelectModal v-if="folders_modal_visible === true"
              @folderSubmit="onFolderSubmit"
              @modalWindowClose="onFoldersModalClose()"
            />
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import {onBeforeMount, defineProps} from 'vue';
  import {ref, reactive}              from 'vue';
  import {useRoute, useRouter}        from 'vue-router';
  import SectionViewLayout            from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue'
  import FoldersSelectModal           from '@/vue/Views/Folders/Modals/FoldersSelectModal.vue';
  import ConfirmModal                 from '@/vue/Views/Webmail/Modals/ConfirmModal.vue';
  import PropertiesValidation         from '@/js/Shared/Validation/PropertiesValidation.js';
  import Language                     from '@/js/Shared/Language/Language.js';
  import StateConsumer                from '@/js/Shared/State/StateConsumer';
  import InputText                    from '@/vue/Elements/Inputs/InputText.vue';
  import InputRadio                   from '@/vue/Elements/Inputs/InputRadio.vue';
  import InputSelect                  from '@/vue/Elements/Inputs/InputSelect.vue';
  import InputCheckboxList            from '@/vue/Elements/Inputs/InputCheckboxList.vue';

  const props = defineProps({
    filters_controller    : {},
    content_state         : {},
  })

  const route                       = useRoute();
  const router                      = useRouter();
  const filter                      = ref();
  const delete_warning_visible      = ref(false);
  const folders_modal_visible       = ref(false)
  const folders_select_state        = 'filters_folder_select';
  const conditions_recipients_state = 'filters_conditions_recipients';
  const properties_validation       = reactive(new PropertiesValidation());
  const condition_keys              = ref();
  const form_already_submitted      = ref(false);

  onBeforeMount(async () => {
    props.content_state.onLoaded(() => {
      setConditionKeys();
      setFilter();

      if (StateConsumer.peek(folders_select_state)) {
        setFilterFolder(StateConsumer.consume(folders_select_state));
      }

      if (StateConsumer.peek(conditions_recipients_state)) {
        setFilterRecipients(StateConsumer.consume(conditions_recipients_state));
      }
    })
  })

  const onConditionAdd = () => {
    props.filters_controller.data.setFilterDefaultCondition(filter.value);
  }

  const onConditionDelete = (index) => {
    filter.value.removeCondition(index)
  }

  const onFoldersModalOpen = () => {
    setFoldersModalVisibility(true);
  }

  const onFoldersModalClose = () => {
    setFoldersModalVisibility(false);
  }

  const onDeleteFilter = () => {
    setDeleteWarningVisible(true);
  }

  const onDeleteCancel = () => {
    setDeleteWarningVisible(false);
  }

  const onDeleteConfirm = async () => {
    setDeleteWarningVisible(false);

    if (await deleteFilter() === true) {
      close();
    }
  }

  const onFolderSubmit = (folder) => {
    filter.value.action_value = folder.imap;
    validateFields();
    setFoldersModalVisibility(false);
  }

  const onValidateFieldsAfterSubmission = () => {
    if(form_already_submitted.value){
      validateFields();
    }
  }

  const onFilterSave = async () => {
    form_already_submitted.value = true;

    if (validateFields() === false) {
      scrollToId('sf_ref_' + properties_validation.getFirstInvalid());
      return;
    }

    if(saveFilter() === false) {
      return
    }

    close()
  }

  const onRemoveFolderSelected = () => {
    filter.value.action_value = null;
  }

  const setFilter = () => {
    filter.value = props.filters_controller.data.getFilterCloneWithDefaults(route.params.id);
  }

  const setConditionKeys = () => {
    condition_keys.value = props.filters_controller.data.metadata.getConditionsKeys();
  }

  const setFilterFolder = (folder) => {
    filter.value.action_value = folder.imap;
  }

  const setFilterRecipients = (recipients) => {
    if (!recipients.length) {
      return;
    }

    filter.value.removeCondition(0);

    recipients.forEach(email => {
      let condition   = props.filters_controller.data.setFilterDefaultCondition(filter.value);
      condition.value = email;
    });
  }

  const validateFields = () => {
    let validation = props.filters_controller.data.getFilterConditionsValidationRules(filter.value);
    let rules      = Object.assign({}, getRule('name'), validation.rules);
    let fields     = Object.assign({}, validation.conditions);
    fields.name    = filter.value.name;

    if (filter.value.action === "Ingo_Rule_User_Move") {
      rules         = Object.assign(rules, getRule('folder'));
      fields.folder = filter.value.action_value;
    }

    if (filter.value.action === "Ingo_Rule_User_FlagOnly") {
      rules        = Object.assign(rules, getRule('flags'));
      fields.flags = props.filters_controller.data.getFilterSelectedFlags(filter.value).join(',');
    }

    properties_validation.setRules(rules)
    return properties_validation.validateObject(fields)
  }

  const saveFilter = async () => {
    props.content_state.setSaving(true);
    let result = await props.filters_controller.saveFilter(filter.value);
    props.content_state.setSaving(false);
    return result;
  }

  const deleteFilter = async () => {
    props.content_state.setSavingInline(true);
    let result = await props.filters_controller.deleteFilter(filter.value);
    props.content_state.setSavingInline(false);
    return result
  }

  const scrollToId = (id) => {
    document.getElementById(id).scrollIntoView({block: "end", behavior: "smooth"});
  }

  const getRule = (name) => {
    return {
      [name] : {
        'required' : true,
      }
    }
  }

  const setFoldersModalVisibility = (value) => {
    folders_modal_visible.value = value
  }

  const setDeleteWarningVisible = (value) => {
    delete_warning_visible.value = value;
  }

  const close = () => {
    router.push('/settings/filters');
  }

</script>
